import React from 'react';
import styles from './styles';

const PatientStudyDetails = props => {
  const {brief_title, nct_id, url, gov_url, studyContact} = props.data;
  const displayItems = [
    ['NCT', nct_id],
    ['Brief Title', brief_title],
    ['ClinicalTrials.gov Link', `https://clinicaltrials.gov/ct2/show/${nct_id}`],
    ['Study Contact', studyContact]
  ]
  return (
    <div style={styles.container}>
      {displayItems.map((item, i) => (
        <div style={styles.displayItem} key={i}>
          <h6 style={styles.itemTitle}>{item[0]}</h6>
          <p style={styles.itemValue}>{item[1] || 'N/A'}</p>
        </div>
    ))}
    </div>
  )
}

export default PatientStudyDetails;
